import React, { Component } from "react";
import moment from "moment-timezone";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import BonusesTable from "./bonusesTable";
import Pagination from "../../components/common/pagination";
import { getBonuses } from "../../services/bonusService";
import SearchBox from "../../components/searchBox";
import LoadingIndicator from "../../components/common/LoadingIndicator";

class Bonuses extends Component {
  state = {
    bonuses: [],
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    searchQuery: "",
    sortColumn: { path: "id", order: "desc" },
    // FIXME: Move status to centralized location
    status: [
      { id: 0, label: "New", value: 0 },
      { id: 1, label: "Paid", value: 1 },
      { id: 2, label: "Completed", value: 2 },
      { id: 3, label: "Canceled", value: 3 },
    ],
    cards: [
      { 
        path: "current_day",
        name: "Today", 
        number: "", 
        icon: <i className="fa fa-code-fork" />, 
        background: "primary" 
      },
      { 
        path: "current_week",
        name: "This Week", 
        number: "", 
        icon: <i className="fa fa-ticket" />, 
        background: "danger" 
      
      },
      { 
        path: "current_month",
        name: "This Month", 
        number: "", 
        icon: <i className="fa fa-database" />, 
        background: "success" 
      },
      { 
        path: "current_year",
        name: "This Year", 
        number: "", 
        icon: <i className="fa fa-users" />, 
        background: "info" 
      },
    ],
    selectedFilter: "total",
    loading: true,
  };

  formatDate (date) {
    if (!date) return "";
    const momentDate = moment(date);
    if (!momentDate.isValid()) return "";
    return momentDate.format("Do MMM. YYYY").toString();
  }

  async populateBonuses() {
    if (!this.state.loading) this.setState({ loading: true });

    const { currentPage, pageSize, searchQuery, sortColumn, selectedFilter } = this.state;

    const params = {
      page: currentPage,
      pageSize,
      search: searchQuery || undefined,
      sortBy: sortColumn?.path || 'createdAt',
      sortOrder: sortColumn?.order || 'DESC',
    };

    const timezone = 'Africa/Lagos';
    const now = moment().tz(timezone);
    if (selectedFilter && selectedFilter !== 'total') {
      let from;
      let to;
      if (selectedFilter === 'current_day') {
        from = now.clone().startOf('day');
        to = now.clone().endOf('day');
      } else if (selectedFilter === 'current_week') {
        from = now.clone().startOf('week');
        to = now.clone().endOf('week');
      } else if (selectedFilter === 'current_month') {
        from = now.clone().startOf('month');
        to = now.clone().endOf('month');
      } else if (selectedFilter === 'current_year') {
        from = now.clone().startOf('year');
        to = now.clone().endOf('year');
      }

      if (from && to) {
        params.from = from.toISOString();
        params.to = to.toISOString();
      }
    }

    const response = await getBonuses(params);
    const payload = response?.data;
    const bonuses = Array.isArray(payload) ? payload : (payload?.data || []);
    const totalCount = payload?.pagination?.totalCount ?? bonuses.length;

    this.setState({ bonuses, totalCount, loading: false });
  };

  formatNumber = (number) => {
    return new Intl.NumberFormat('en-US').format(number);
  };

  async populateCounters() {
    const bonuses = this.state.bonuses;
    const timezone = 'Africa/Lagos';
    const NOW = moment().tz(timezone).endOf('day');

    const current_day = bonuses.filter(p => 
      moment.tz(p.createdAt, timezone).isSame(NOW, 'day')
    ).length;

    const current_week = bonuses.filter(p => 
      moment.tz(p.createdAt, timezone).isSame(NOW, 'week')
    ).length;

    const current_month = bonuses.filter(p =>
      moment.tz(p.createdAt, timezone).isSame(NOW, 'month')
    ).length;

    const current_year = bonuses.filter(p =>
      moment.tz(p.createdAt, timezone).isSame(NOW, 'year')
    ).length;

    const Cards = this.state.cards.map(obj => {
      let number;
      switch (obj.path) {
        case 'current_day':
          number = current_day;
          break;
        case 'current_week':
          number = current_week;
          break;
        case 'current_month':
          number = current_month;
          break;
        case 'current_year':
          number = current_year;
          break;
        default:
          number = 0;
      }
      return {...obj, number: this.formatNumber(number)};
    });

    this.setState({ cards: Cards });
}

  async componentDidMount() {
    await this.populateBonuses();

    // this.populateCounters();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location?.state?.refreshToken !== this.props.location?.state?.refreshToken) {
      this.setState({
        currentPage: 1,
        searchQuery: "",
        selectedFilter: "total",
        sortColumn: { path: "id", order: "desc" },
        loading: true,
      }, () => {
        this.populateBonuses();
      });
    }
  }

  handleDelete = async bonus => {
    const originalBonuses = this.state.bonuses;
    const bonuses = originalBonuses.filter(a => a.id !== bonus.id);
    this.setState({ bonuses });

    try {
      await deleteBonus(bonus.id);
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        toast.error("This bonus has already been deleted.");

      this.setState({ bonuses: originalBonuses });
    }
    toast.success("Bonus #" + bonus.id + " deleted.");
  };

  handleLike = bonus => {
    const bonuses = [...this.state.bonuses];
    const index = bonuses.indexOf(bonus);
    bonuses[index] = { ...bonuses[index] };
    bonuses[index].liked = !bonuses[index].liked;
    this.setState({ bonuses });
  };

  handlePageChange = page => {
    this.setState({ currentPage: page }, () => {
      this.populateBonuses();
    });
  };

  handleGenreSelect = genre => {
    this.setState({ selectedGenre: genre, searchQuery: "", currentPage: 1 });
  };

  handleSearch = query => {
    this.setState({ searchQuery: query, selectedGenre: null, currentPage: 1 }, () => {
      this.populateBonuses();
    });
  };

  handleSort = sortColumn => {
    this.setState({ sortColumn }, () => {
      this.populateBonuses();
    });
  };

  handleCardClick = path => {
    this.setState({ selectedFilter: path, currentPage: 1 }, () => {
      this.populateBonuses();
    });
  };

  render() {
    const { pageSize, currentPage, sortColumn, searchQuery, selectedFilter } = this.state;
    const { user } = this.props;
    const totalCount = this.state.totalCount;
    const bonuses = this.state.bonuses;

    return (
      <React.Fragment>
        <div className="row border-top mt-3 pt-3 mx-2">
          <div className="col">
            <div>
              {this.state.loading && <LoadingIndicator message="Loading bonuses..." />}
              {!this.state.loading &&
              <div>
                <p>
                  There {totalCount === 0 ? " are no " : " were " + totalCount} bonus{
                  (totalCount>1 || totalCount===0) && "es"
                  } {
                  selectedFilter === "total" ? "available" : 
                  selectedFilter === "current_day" ? "today" : 
                  selectedFilter === "current_week" ? "this week" : 
                  selectedFilter === "current_month" ? "this month" : 
                  selectedFilter === "current_year" ? "this year" : 
                  `for ${selectedFilter}` 
                  }.
                </p>
              </div>}
            </div>
            <SearchBox value={searchQuery} onChange={this.handleSearch} placeholder={'Enter an account, a bonus id, or a reason to search...'}/>
            <BonusesTable
              bonuses={bonuses}
              sortColumn={sortColumn}
              onLike={this.handleLike}
              onDelete={this.handleDelete}
              onSort={this.handleSort}
            />
            <Pagination
              itemsCount={totalCount}
              pageSize={pageSize}
              currentPage={currentPage}
              onPageChange={this.handlePageChange}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Bonuses;
